// extracted by mini-css-extract-plugin
export var dropdown = "_qc-0";
export var imageWrapper = "_qc-3";
export var itemNameContainer = "_qc-1";
export var productImage = "_qc-2";
export var spinnerWrapper = "_qc-4";